<template>
  <!-- 机台预览 -->
  <div class="rzy-page">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="车间选择">
        <el-select v-model="value1" placeholder="请选择">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序方式">
        <el-select v-model="value2" placeholder="请选择">
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div style="margin-bottom:10px">
      <el-button
        v-for="(obj, index) in stateTabList"
        :key="index"
        :type="obj.type"
        @click="changeState(index)"
      >
        {{ obj.title + ":" + obj.content }}
      </el-button>
    </div>
    <div class="container-machine-preview">
      <machine-preview-item
        v-for="(item, index) in machineItemList"
        :key="index"
        :item="item"
        @click-work-order="showWorkOrderDialog"
      />
    </div>
    <work-order-details ref="workOrderDetails" />
  </div>
</template>

<script>
import { workOrderDetails } from "@/components/projectComponents";
import { machinePreviewItem } from "./components";
import * as api from "@/api/factory/machine/preview";
import tabConfig from "./machineTabConfig.js";
export default {
  components: {
    machinePreviewItem,
    workOrderDetails,
  },
  data() {
    return {
      dummy: null,
      machineItemList: [],
      intervalId: null,
      // 这个是给el-button的数据，有什么状态，该状态的机台有几个，并没有详细的机台数据。
      stateTabList: [],
      // 每种状态缓存的数据,这样频繁切换不用去请求。
      stateTabCache: [],
      // 当前所选择的状态，默认选择全部
      selectTabIndex: 0,
      value1: 0,
      value2: 0,
      options1: [
        {
          value: 0,
          label: "经编",
        },
        {
          value: 1,
          label: "整经",
        },
        {
          value: "",
          label: "全部",
        },
      ],
      options2: [
        {
          value: 0,
          label: "按名称",
        },
        {
          value: 1,
          label: "开机率",
        },
        {
          value: 2,
          label: "停机数",
        },
        {
          value: 3,
          label: "疵点数",
        },
      ],
    };
  },
  created() {
    this.getList().then((res) => {
      this.dataRefreh();
    });
  },
  methods: {
    // 获取机台预览所需数据
    getList() {
      return api.getList({ kind: this.value1 }).then((res) => {
        console.log(res);
        this.dummy = res.data.dummy;
        console.log(this.dummy);

        //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--sta
        // this.stateTabList = this.countStateTab(this.initResponse(res.data))
        this.stateTabList = this.countStateTab(
          this.initResponse(res.data.machineState, res.data.serverTime)
        );
        console.log(this.stateTabList);
        //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--end
        this.machineItemList = this.stateTabCache[this.selectTabIndex]
          ? this.stateTabCache[this.selectTabIndex]
          : [];
        console.log(this.machineItemList);
        if (this.value2 == 0) {
          return this.machineItemList;
        } else if (this.value2 == 1) {
          return this.machineItemList.sort(function(a, b) {
            return b.availability - a.availability;
          });
        } else if (this.value2 == 2) {
          return this.machineItemList.sort(function(a, b) {
            return b.todayHaltCounts - a.todayHaltCounts;
          });
        } else if (this.value2 == 3) {
          return this.machineItemList.sort(function(a, b) {
            return b.todayDefectCounts - a.todayDefectCounts;
          });
        }
      });
    },
    // 格式化返回数据
    initResponse(res, serverTime) {
      console.log(res);
      var arr = [];
      if (this.dummy == 1) {
        var list1 = res;
        var list2 = this.utils.deepClone(list1);
        var list3 = this.utils.deepClone(list1);
        var list4 = list3.slice(0, 2);
        console.log(list1, list2, list4);
        if (this.value1 == 1) {
          var currentMachineNumber = list1.length + 1;

          // 更新 arr2 的 machineNumber
          list2.forEach(function(item) {
            item.machineNumber = ("整" + currentMachineNumber++).toString();
          });
        } else {
          var currentMachineNumber = list1.length + 5;

          // 更新 arr2 的 machineNumber
          list2.forEach(function(item) {
            item.machineNumber = (currentMachineNumber++).toString();
          });
          var arr1 = list1.concat(list2);
          console.log(arr1);
          var currentMachineNumber1 = arr1.length + 5;
          list4.forEach(function(item) {
            item.machineNumber = (currentMachineNumber1++).toString();
          });
        }

        if (this.value1 == 1) {
          arr = list1.concat(list2);
        } else {
          arr = arr1.concat(list4);
        }
        // arr = arr1.concat(list4);
        console.log(arr);
      } else if (this.dummy == 0) {
        arr = res;
      }

      // 依照机台编号进行排序  liuqy  微信方式搬过来
      var response = this._.sortBy(arr, (obj, index) => {
        // console.log(obj);
        // 默认升序 降序return的结果加 - ，-obj.machine.number
        // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
        var machineNumber = obj.machineNumber.replace(/[^0-9]+/gi, "");
        return Number(machineNumber);
      });

      response = this.judgeOffline(response, serverTime);
      response.forEach((item, index) => {
        // console.log(index);
        // item.machineNumber = index + 1;

        item.lastChangeStatus = this.utils.timestampToTime(
          item.lastChangeStatus
        );
        // 多个工人名字的处理
        item.workerName = "暂无";
        item.workersMsg = "暂无";
        if (!this.utils.isEmpty(item.workers)) {
          var workersMsg = "";
          item.workers.forEach((worker) => {
            if (worker.role === this.$enum.roleObj.dangche.value) {
              item.workerName = worker.username;
            }
            workersMsg += ` ${worker.username}
              [${this.$enum.roleArr[this.utils.formatEnum(worker.role)[0]]}]`;
          });
          item.workersMsg = workersMsg;
        }
        // 计算开机率
        if (item.todayRunTime > 0) {
          //   item.todayRunTime *= 1000;
          //   //let sendTime=item.sendTime
          //   let sendTime = this.utils.getNowTime();
          if (this.value1 == 0) {
            item.availability = (
              (item.todayRunTime / (item.todayRunTime + item.downTime)) *
              100
            ).toFixed(2);
          } else if (this.value1 == 1) {
            item.availability = (
              (item.todayRunTime / item.userTime) *
              100
            ).toFixed(2);
          }

          //   item.availability =
        } else {
          item.availability = 0;
        }
        // if (this.value1 == 0) {
        //   return item.kind = this.value1;
        // } else if (this.value1 == 1) {
        //   return item.kind = this.value1;
        // } else if (this.value1 == "") {
        //   return item.kind = item.machineKind;
        // }

        // 计算状态持续时间
        if (item.machineWorkingState === -1) {
          //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--sta
          // item.duringTime =
          //     `状态已持续:${this.utils.milliToHour(new Date().getTime() - item.unixTime)}小时`
          item.duringTime = `状态已持续:${this.utils.milliToHour(
            serverTime - item.unixTime
          )}小时`;
          //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--end
        } else {
          if (item.duringTime) {
            item.duringTime = `状态已持续:${this.utils.secondToHour()}`;
          } else {
            item.duringTime = "无状态持续时间";
          }
        }
      });
      return response;
    },
    // 展示机台正在生产的工单详情
    showWorkOrderDialog(machineId, num, kind) {
      this.$refs.workOrderDetails.show(machineId, num, kind);
    },
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getList(); // 加载数据函数
      }, 3000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); // 清除计时器
      this.intervalId = null; // 设置为null
    },
    judgeOffline(response, serverTime) {
      //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--sta
      // const now = new Date().getTime()
      const now = serverTime;
      //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--end
      response.forEach((obj) => {
        const dValue = now - obj.unixTime;
        if (dValue > 60000) {
          obj.machineWorkingState = -1;
        }
      });
      return response;
    },
    // 这个是计算什么状态的机台有几台,用于d-point-tab
    countStateTab(response) {
      const stateTabGroup = this._.groupBy(response, (item) => {
        // 先赋值默认的状态，以防可能出现找不到的情况
        var tabIndex = tabConfig.tabDefault;
        const arr = this.$enum.stateTab;
        const state = Number(item.machineWorkingState);
        try {
          arr.forEach((stateArr, index) => {
            if (this._.indexOf(stateArr, state) !== -1) {
              tabIndex = index + 1;
              // 如果已经找到状态，那么抛异常结束循环
              throw new Error("stop forEach");
            }
          });
        } catch (e) {
          if (e.message !== "stop forEach") throw e;
        }
        return tabIndex;
      });
      stateTabGroup[tabConfig.allIndex] = response;
      console.log(stateTabGroup);
      this.stateTabCache = stateTabGroup;
      const formatArr = [];
      // 按d-point-tab要求的数据格式进行拼接
      tabConfig.tabInfo.forEach((obj, index) => {
        formatArr.push({
          title: obj.name,
          content: stateTabGroup[index]
            ? `${stateTabGroup[index].length}台`
            : "0台",
          type: obj.type,
        });
      });
      console.log(formatArr);

      return formatArr;
    },
    changeState(index) {
      if (this.stateTabCache[index]) {
        this.selectTabIndex = index;
        this.machineItemList = this.stateTabCache[index];
      }
    },
  },

  beforeDestroy() {
    // // 在页面销毁后，清除计时器
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.container-machine-preview {
  margin: -5px 0 0 0px;
  display: flex;
  flex-wrap: wrap;
}
</style>
